
import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { X, Plus } from "lucide-react";

interface SpecializationsSectionProps {
  formData: {
    specializations: string[];
  };
  onInputChange: (field: string, value: string[]) => void;
}

export default function SpecializationsSection({ formData, onInputChange }: SpecializationsSectionProps) {
  const [newSpecialization, setNewSpecialization] = useState('');

  const addSpecialization = () => {
    if (newSpecialization.trim() && !formData.specializations.includes(newSpecialization.trim())) {
      onInputChange('specializations', [...formData.specializations, newSpecialization.trim()]);
      setNewSpecialization('');
    }
  };

  const removeSpecialization = (spec: string) => {
    onInputChange('specializations', formData.specializations.filter(s => s !== spec));
  };

  return (
    <div>
      <Label>Specializations</Label>
      <div className="flex gap-2 mb-2">
        <Input
          placeholder="Add specialization"
          value={newSpecialization}
          onChange={(e) => setNewSpecialization(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && addSpecialization()}
        />
        <Button onClick={addSpecialization} size="sm">
          <Plus className="h-4 w-4" />
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {formData.specializations.map((spec, index) => (
          <Badge key={index} variant="outline" className="flex items-center gap-1">
            {spec}
            <X 
              className="h-3 w-3 cursor-pointer" 
              onClick={() => removeSpecialization(spec)}
            />
          </Badge>
        ))}
      </div>
    </div>
  );
}
